import React, { useState } from 'react';
import { Globe } from 'lucide-react';

interface URLInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  required?: boolean;
}

export function URLInput({ value, onChange, placeholder = "Enter website URL", error, required = false }: URLInputProps) {
  const [isFocused, setIsFocused] = useState(false);

  const validateURL = (url: string): boolean => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let url = e.target.value;
    
    // Add https:// if not present and there's a value
    if (url && !url.match(/^https?:\/\//)) {
      url = `https://${url}`;
    }
    
    onChange(url);
  };

  return (
    <div>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Globe className={`h-5 w-5 ${isFocused ? 'text-indigo-500' : 'text-gray-400'}`} />
        </div>
        <input
          type="url"
          value={value}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          className={`w-full pl-10 pr-3 py-2 rounded-md border ${
            error 
              ? 'border-red-300 focus:border-red-500 focus:ring-red-500' 
              : 'border-gray-300 focus:border-indigo-500 focus:ring-indigo-500'
          } shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2`}
          required={required}
        />
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
      {value && !validateURL(value) && !error && (
        <p className="mt-1 text-sm text-yellow-600">Please enter a valid URL (e.g., https://example.com)</p>
      )}
    </div>
  );
}